import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=87b89a32&scoped=true&lang=pug"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"
import style0 from "./Images.vue?vue&type=style&index=0&id=87b89a32&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b89a32",
  null
  
)

export default component.exports